import Currencies from 'arbitrip-common/general/utils/Currencies';

const MONEY_PRECISION = 2;

// Cash wallets are currency-locked to USD/ILS, both of which prefix their symbol.
// ⚠ Documented, not endorsed: Currencies.getPriceByPrecision clamps with
// Math.max(numPrice, 0), so a negative renders as a confident "$0.00". Harmless today — no request
// money field (net/vat/amount) is ever negative — and out of scope to fix: Currencies is app-wide.
export const formatMoney = (value, currency) =>
    Currencies.getSymbol(currency) + Currencies.getPriceByPrecision(value, MONEY_PRECISION);

// The balance header renders the symbol as its own element, so it needs the digits alone — but they
// must stay byte-identical to formatMoney's, or the same figure reads "$1234.50" in the header and
// "$1,234.50" in the drawers. Hence both halves: 2 decimals AND thousands grouping. The locale is
// intentionally omitted to mirror getPriceByPrecision's toLocaleString(undefined, …); pinning 'en-US'
// would diverge from it under a non-en runtime locale. Unlike formatMoney, the sign is preserved —
// the header does render a negative balance (see Popover.NegativeBalanceTitle).
export const formatAmountWithoutSymbol = (amount) =>
    (amount < 0 ? '-' : '') +
    Math.abs(amount).toLocaleString(undefined, {
        minimumFractionDigits: MONEY_PRECISION,
        maximumFractionDigits: MONEY_PRECISION,
    });
